import React from 'react'

const Cancel = props => (
  <svg width={18} height={18} viewBox="0 0 18 18" {...props}>
    <path
      d="M10.4 9l7-7a1 1 0 000-1.39A1 1 0 0016 .6l-7 7-7-7A1 1 0 00.61.6 1 1 0 00.6 2l7 7-7 7A1 1 0 002 17.4l7-7 7 7a1 1 0 001.4-1.4l-7-7z"
      fill={props.fill || '#1A344F'}
    />
  </svg>
)

export default Cancel
